import {FormSectionType} from '../../../../blocks/FormBlock'
import {copy} from '../../../../../util/fieldscopy'
import typeField from '../fields/typeField'

const sectionId: number = 1
const typeSection: FormSectionType = {
	id: sectionId,
	parent_id: 0,
	channel: 'section',
	label: `${copy?.step || 'Stap'} 1`,
	fields: [{...typeField, id: 1, parent_id: sectionId}]
}

export default typeSection
